import { Box, Dialog, Typography } from '@mui/material';
import type { BackupVault } from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import useBackupVaults from '@/data/vaults/useBackupVaults';

import { BackupVaultSelection } from './backupVaultSelection';
interface BackupVaultSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (vault: BackupVault) => void;
  scheduleWindow: string;
  selectedVaults: string[];
  vaultsPredicate?: (vault: BackupVault) => boolean;
  isLoading: boolean;
}

export function BackupVaultSelectionDialog(
  props: BackupVaultSelectionDialogProps
) {
  const { vaults, isLoading: isLoadingVaults } = useBackupVaults();

  const filteredVaults = useMemo(
    () =>
      props.vaultsPredicate ? vaults.filter(props.vaultsPredicate) : vaults,
    [props.vaultsPredicate, vaults]
  );

  return (
    <Dialog
      disablePortal
      onClose={props.onClose}
      hideBackdrop
      open={props.open}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '744px',
          width: '744px',
          minWidth: '744px',
          maxHeight: '40%',
          minHeight: '480px',
          margin: 0,
          borderRadius: '16px',
        },
      }}
    >
      <Typography margin='32px 40px 20px'>
        {`Choose a vault for your ${props.scheduleWindow}`}
      </Typography>
      <Box margin='0 40px 40px'>
        <BackupVaultSelection
          onSelect={props.onSelect}
          selectedVaults={props.selectedVaults}
          loading={props.isLoading || isLoadingVaults}
          vaults={filteredVaults}
        />
      </Box>
    </Dialog>
  );
}
